import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router";
import Toolbar from "../../components/toolbar/toolbar";
import { useActiveBroadcasts } from "../../hooks/use-active-broadcasts";
import type { BroadcastSummary } from "../../types/broadcasts.types";
import FollowButton from "../../components/follow-button/follow-button";
import { useAuth } from "../../hooks/use-auth";
import { useBroadcastScore } from "../../hooks/use-broadcast-score";
import { useCurrentUser } from "../../hooks/use-current-user";
import { useFollowingBroadcasts } from "../../hooks/use-following-broadcasts";
import { resetBroadcast } from "../../redux/broadcast/broadcast.actions";
import {
	selectAwayTeam,
	selectBroadcastId,
	selectHomeTeam,
} from "../../redux/broadcast/broadcast.selectors";

const BroadcastCard = ({ broadcast }: { broadcast: BroadcastSummary }) => (
	<div>
		<Link to={`/broadcast/${broadcast.id}`}>
			<strong>{broadcast.homeTeam} {broadcast.homeScore} – {broadcast.awayScore} {broadcast.awayTeam}</strong>
		</Link>
		{broadcast.status === "live" && <span> 🔴 LIVE</span>}
		{broadcast.authorName && broadcast.userId && (
			<span> · <Link to={`/author/${broadcast.userId}`}>{broadcast.authorName}</Link>{" "}<FollowButton authorId={broadcast.userId} /></span>
		)}
	</div>
);

const Home = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const authState = useAuth();
	const broadcastId = useSelector(selectBroadcastId);
	const homeTeam = useSelector(selectHomeTeam);
	const awayTeam = useSelector(selectAwayTeam);
	const { live, upcoming } = useActiveBroadcasts();
	const currentUser = useCurrentUser();
	const following = useFollowingBroadcasts(currentUser?.uid ?? null);
	const { endedAt } = useBroadcastScore(broadcastId);

	const handleStartNew = () => {
		dispatch(resetBroadcast());
		navigate("/new");
	};

	return (
		<div>
			<Toolbar />

			{following.length > 0 && (
				<section>
					<h2>From people you follow</h2>
					{following.map((b) => <BroadcastCard key={b.id} broadcast={b} />)}
				</section>
			)}

			{live.length > 0 && (
				<section>
					<h2>Live now</h2>
					{live.map((b) => <BroadcastCard key={b.id} broadcast={b} />)}
				</section>
			)}

			{upcoming.length > 0 && (
				<section>
					<h2>Coming up</h2>
					{upcoming.map((b) => <BroadcastCard key={b.id} broadcast={b} />)}
				</section>
			)}

			{live.length === 0 && upcoming.length === 0 && (
				<p>No broadcasts right now.</p>
			)}

			<section>
				{authState === "authenticated" ? (
					<div>
						{broadcastId && !endedAt && (
						<div>
							<span>{homeTeam} vs {awayTeam}</span>
							{" "}<Link to="/broadcast">Resume</Link>
						</div>
					)}
						<button type="button" onClick={handleStartNew}>Start new broadcast</button>
					</div>
				) : (
					<div>
						<p>Want to start broadcasting? <Link to="/login">Sign in</Link> or <Link to="/register">create an account</Link>.</p>
					</div>
				)}
			</section>
		</div>
	);
};

export default Home;
